import { RefNumber, CollectionPrinter } from "@tblabs/truffle";
import { Basket } from "../../../Services/Basket/Basket";
import { DiscountInput } from "./DiscountInput";
import { SingleCostBox } from "./DiscountSwitcherBox";
import { Accordion } from "../../../Components/Utils/Accordion/Accordion";


export class DiscountBox extends Accordion
{
    constructor(_basket: Basket, price: RefNumber)
    {
        super("Rabaty", [
            new CollectionPrinter(_basket.Discounter.Discounts,
                discount => new SingleCostBox(discount, price))
                .Class("product__discounts"),
            new DiscountInput(_basket.Discounter).MarginTop(4),
        ], "open-discounts-accordion-btn");
    }
}

export class ExtraBox extends Accordion
{
    constructor(_basket: Basket, price: RefNumber)
    {
        super("Opłaty dodatkowe", [
            new CollectionPrinter(_basket.Discounter.Extras, extra => new SingleCostBox(extra, price))
                .Class("product__discounts"),
        ]);
    }
}

